module.exports = __webpack_public_path__ + "img/forte3.9a296556.jpeg";